export function navigateToHash(href) {
  window.location.hash = href;
}
